export default "__VITE_ASSET__xcpjkyKw__"